// extracted by mini-css-extract-plugin
export default {"noTagsTitle":"NoTags_noTagsTitle__lYb17","noTagsSubTitle":"NoTags_noTagsSubTitle__Gh2rC","button":"NoTags_button__3dp9w","templateImg":"NoTags_templateImg__ioxi0"};